
import { notification } from "antd";
import axios from "axios";

const axiosInstance = axios.create();
let notificationQueue = [];

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const data = error.response?.data;
    if (status === 401) {
      try {
        setTimeout(() => {
          showNotifications();
        }, 4000);
        await new Promise((resolve) => setTimeout(resolve, 8000));
        sessionStorage.clear();
        notificationQueue.push({ type: "error", message: "Session has expired! Please relogin" });
        window.location.href = "/";
      } catch (navError) {
        console.error("Navigation to login failed:", navError);
      }
    } else
      if (status === 500) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      } else if (status === 400) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      }
      else if (status === 200) {
        notificationQueue.push({ type: "error", message: data?.error });
        setTimeout(() => {
          showNotifications();
        }, 5000);
      }

    return Promise.reject(error);
  }
);

function showNotifications() {
  if (notificationQueue?.length >= 1) {
    const uniqueErrorMessages = Array.from(
      new Set(notificationQueue.map((item) => item.message))
    );
    const firstErrorMessage = uniqueErrorMessages;
    notification.error({ message: firstErrorMessage })
    notificationQueue = [];
  }
}

class HttpRequest {
  static async get(url, token) {
    try {
      const res = await axiosInstance({
        method: "GET",
        url,
        headers: {
          "token": token,
        },
      });
      return res.data;
    } catch (err) {
      return err;
    }
  }

  static async post(url, data, token) {
    try {
      const res = await axiosInstance({
        method: "POST",
        url,
        headers: {
          "token": token,
        },
        data,
      });

      return res.data;
    } catch (err) {
      console.error(err);
      return err;
    }
  }

  static async delete(url, token, data) {
    try {
      const res = await axiosInstance({
        method: "DELETE",
        url,
        headers: {
          "token": token,
        },
        data,
      });

      return res.data;
    } catch (err) {
      console.error(err.response);
      return err;
    }
  }

  static async update(url, data, token) {
    try {
      const res = await axiosInstance({
        method: "PUT",
        url,
        headers: {
          "token": token,
        },
        data,
      });

      return res.data;
    } catch (err) {
      return err;
    }
  }

  static async upload(url, data, token) {
    try {
      const res = await axiosInstance({
        method: "POST",
        url,
        data,
        headers: {
          "content-type": "multipart/form-data",
          "authToken": token,
        },
      });

      return res.data;
    } catch (err) {
      return err;
    }
  }
}

export default HttpRequest;

